type Props = {
    children: string
}

export function Label({ children }: Props) {
    return <label>{children}</label>
}
